import {Component, EventEmitter, forwardRef, Input, Output, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonSize, ButtonState, ButtonType } from '../../../assets/types/dtoTypes';
import {TranslateModule} from "@ngx-translate/core";
import {MatHint, MatInput, MatLabel} from "@angular/material/input";
import {MatFormField} from "@angular/material/select";
import {ButtonComponent} from "../button/button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-input-area',
  templateUrl: './app-input-area.component.html',
  styleUrls: ['./app-input-area.component.scss'],
  standalone: true,
  imports: [
    MatHint,
    MatLabel,
    MatFormField,
    TranslateModule,
    ButtonComponent,
    MatInput,
    NgIf
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppInputAreaComponent),
      multi: true,
    },
  ]
})
export class AppInputAreaComponent implements ControlValueAccessor {

  @Input() fontSize = '';

  @Input() isEditable = false;

  @Input() placeholder: string = '';

  @Input() withSubmit = false;

  @Input() label = '';

  @Input() defaultText: string | undefined = '';

  @Output() text = new EventEmitter<string>();

  @Output() savedText = new EventEmitter<string>();

  value: string = '';

  isDisabled: boolean = false;

  onChange: ( value: string ) => void = () => {};

  onTouched: () => void = () => {};


  registerOnChange( fn: ( value: string ) => void ): void {
    this.onChange = fn;
  }

  registerOnTouched( fn: () => void ): void {
    this.onTouched = fn;
  }

  setDisabledState?( isDisabled: boolean ): void {
    this.isDisabled = isDisabled;
  }

  onInputChange( value: string ) {
    this.value = value;
    this.onChange( value );
  }

  onInputBlur() {
    this.onTouched();
  }

  changeText( text: string ) {
    this.text.emit( text );
  }

  saveEditedText( text: string ) {
    this.savedText.emit( text );
  }

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;


  ngOnChanges(changes: SimpleChanges): void {
    // If parent changes defaultText (prefill/edit mode), update the textarea
    if (changes['defaultText'] && changes['defaultText'].currentValue !== undefined) {
      // Only override if user hasn't typed something different, or if you always want to force-update:
      this.value = changes['defaultText'].currentValue ?? '';
    }
  }

  writeValue(value: string): void {
    this.value = value ?? '';
  }

  onTextareaInput(event: Event): void {
    const v = (event.target as HTMLTextAreaElement).value;
    this.value = v;
    this.onChange(v);      // CVA
    this.text.emit(v);     // your output event
  }

  isTextEdited(text: string) {
    return text !== (this.defaultText ?? '');
  }
}
